/* global axios */
import ApiClient from './ApiClient';

class CommissionReportsAPI extends ApiClient {
  constructor() {
    super('commissions', { accountScoped: true });
  }

  get({ from, to, id, page } = {}) {
    return axios.get(this.url, {
      params: {
        since: from,
        until: to,
        id: id,
        page,
      },
    });
  }
}

export default new CommissionReportsAPI();
